import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.scss';
import { ForumThreadShape } from 'entities';
import ForumFilteredThreadsListPageSelector from './ForumFilteredThreadsListPageSelector';
import { getForumThreadsOnFrontPage, getForumPaging } from 'selectors';
import { normalizeForumQuery, getQueryTitle } from 'forumQueries';
import ForumThreadsList from 'containers/ForumThreadsList';
import ForumThread from 'containers/ForumThreadsList/ForumThread';
import NoEntries from 'components/NoEntries';
import NoEntriesDetail from 'components/NoEntries/NoEntriesDetail';
import { isLiveNow } from 'forumLiveStatus';

class ForumFilteredThreadsList extends Component {

  renderNoForumThreads() {
    return [
      <ForumThreadsList key="1" title={this.props.title} />,
      <NoEntries key="2" title={__('members.forum.noThreads.title')}>
        <NoEntriesDetail>{__('members.forum.noThreads.subtitle')}</NoEntriesDetail>
      </NoEntries>
    ];
  }

  render() {
    return (
      <div className="ForumFilteredThreadsList has-background has-pagination">
        <div className="wrapper-narrow">

          {(() => {
            if(this.props.forumThreads.length > 0) {
              return (
                <ForumThreadsList title={this.props.title}>
                  {this.props.forumThreads.map(
                    forumThread => <ForumThread
                                    key={forumThread.id}
                                    isLive={isLiveNow(forumThread)}
                                    forumThread={forumThread}
                                    timeInfo={moment(forumThread.createdAt).format(process.env.KOOTH_DATE_FORMAT)}
                                    />
                  )}
                </ForumThreadsList>
              );
            }
            else {
              if(this.props.isFetching) {
                return (
                  <ForumThreadsList title={this.props.title}>
                    <ForumThread key="loader1" isEmpty />
                    <ForumThread key="loader2" isEmpty />
                    <ForumThread key="loader3" isEmpty />
                  </ForumThreadsList>
                );
              }

              return this.renderNoForumThreads();
            }
          })()}
        </div>

        <div className="pagination-wrapper">
          <div className="wrapper-xlarge">
            {this.props.pagesCount > 1 && <ForumFilteredThreadsListPageSelector query={this.props.query} queryString={this.props.queryString} />}
          </div>
        </div>
      </div>
    );
  }
}

ForumFilteredThreadsList.propTypes = {
  forumThreads: PropTypes.arrayOf(ForumThreadShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  queryString: PropTypes.string,
  query: PropTypes.object,
  allowsNewDiscussions: PropTypes.bool,
  startNewDiscussionUrl: PropTypes.string,
  title: PropTypes.string,
  canAskKooth: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const query = normalizeForumQuery(props.location.query);
  const queryString = JSON.stringify(query);
  const { page, isFetching, pagesCount } = getForumPaging(state, 'forumThreads', { queryString });
  const forumThreads = getForumThreadsOnFrontPage(state, { page, queryString });

	return {
    forumThreads,
    isFetching,
    queryString,
    query,
    pagesCount,
    title: getQueryTitle(query)
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumFilteredThreadsList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumFilteredThreadsList/index.js
 **/